"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageApplicationFilled = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.ManageApplicationFilled = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M1.75 4.5C1.75 2.84315 3.09315 1.5 4.75 1.5C6.40685 1.5 7.75 2.84315 7.75 4.5V6.25C7.75 6.94036 7.19036 7.5 6.5 7.5H4.75C3.09315 7.5 1.75 6.15685 1.75 4.5Z", fill: colors[0] }),
            react_1.default.createElement("path", { d: "M14.75 4.5C14.75 2.84315 13.4069 1.5 11.75 1.5C10.0931 1.5 8.75 2.84315 8.75 4.5V6.25C8.75 6.94036 9.30964 7.5 10 7.5H11.75C13.4069 7.5 14.75 6.15685 14.75 4.5Z", fill: colors[0] }),
            react_1.default.createElement("path", { d: "M4.75 14.5C3.09315 14.5 1.75 13.1569 1.75 11.5C1.75 9.84315 3.09315 8.5 4.75 8.5H6.5C7.19036 8.5 7.75 9.05964 7.75 9.75V11.5C7.75 13.1569 6.40685 14.5 4.75 14.5Z", fill: colors[0] }),
            react_1.default.createElement("path", { d: "M11.75 14.5C13.4069 14.5 14.75 13.1569 14.75 11.5C14.75 9.84315 13.4069 8.5 11.75 8.5H10C9.30964 8.5 8.75 9.05964 8.75 9.75V11.5C8.75 13.1569 10.0931 14.5 11.75 14.5ZM13.25 11.5C13.25 12.3284 12.5784 13 11.75 13C10.9216 13 10.25 12.3284 10.25 11.5V10H11.75C12.5784 10 13.25 10.6716 13.25 11.5Z", fill: colors[0], fillRule: "evenodd", clipRule: "evenodd" }));
    },
    name: 'manage_application_filled',
    defaultColors: ['#D9D9D9'],
    colorful: false,
    allPathData: ['M1.75 4.5C1.75 2.84315 3.09315 1.5 4.75 1.5C6.40685 1.5 7.75 2.84315 7.75 4.5V6.25C7.75 6.94036 7.19036 7.5 6.5 7.5H4.75C3.09315 7.5 1.75 6.15685 1.75 4.5Z', 'M14.75 4.5C14.75 2.84315 13.4069 1.5 11.75 1.5C10.0931 1.5 8.75 2.84315 8.75 4.5V6.25C8.75 6.94036 9.30964 7.5 10 7.5H11.75C13.4069 7.5 14.75 6.15685 14.75 4.5Z', 'M4.75 14.5C3.09315 14.5 1.75 13.1569 1.75 11.5C1.75 9.84315 3.09315 8.5 4.75 8.5H6.5C7.19036 8.5 7.75 9.05964 7.75 9.75V11.5C7.75 13.1569 6.40685 14.5 4.75 14.5Z', 'M11.75 14.5C13.4069 14.5 14.75 13.1569 14.75 11.5C14.75 9.84315 13.4069 8.5 11.75 8.5H10C9.30964 8.5 8.75 9.05964 8.75 9.75V11.5C8.75 13.1569 10.0931 14.5 11.75 14.5ZM13.25 11.5C13.25 12.3284 12.5784 13 11.75 13C10.9216 13 10.25 12.3284 10.25 11.5V10H11.75C12.5784 10 13.25 10.6716 13.25 11.5Z'],
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
});
